import React, { useState, useEffect } from "react";
import {
  FaChevronDown,
  FaChevronRight,
  FaChevronUp,
  FaPlay,
  FaInfoCircle,
} from "react-icons/fa";
import { Container, Row, Col, Card, Accordion, Badge } from "react-bootstrap";
import course from "../../../assets/images/course/course-detail.png";
import DOMPurify from "dompurify";
import { useNavigate } from "react-router-dom";
import author from "../../../assets/images/user.png";
// import "./CoursesDetailSubject.css";

const CoursesDetailSubject = () => {
  const [blog, setBlog] = useState();
  const [packagedata, setPackage] = useState([]);
  const [imagePath, setImagePath] = useState("");
  const [expandedSubjects, setExpandedSubjects] = useState({});
  const [activeSubject, setActiveSubject] = useState(null);
  const [chapterContent, setChapterContent] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const packageId = localStorage.getItem("packageId");

  useEffect(() => {
    fetchPackageDetail();
  }, []);

  useEffect(() => {
    if (packagedata.length > 0 && !activeSubject) {
      const firstSubjectId = packagedata[0].id;
      setActiveSubject(firstSubjectId);
      fetchBlogDetail(firstSubjectId); // Default first subject  chapter fetch
    }
  }, [packagedata]);

  const fetchBlogDetail = async (id) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/course-chaptar-details`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ sub_id: id }),
        }
      );
      const data = await response.json();

      if (data.status == 1) {
        setBlog(data.data);
        setImagePath(data.imagePath);

        if (data.data && data.data.length > 0) {
          const contentMap = {};
          data.data.forEach((chapter, index) => {
            contentMap[index] = {
              id: chapter.id,
              title: chapter.chapter_name,
              lessons: chapter.description
                ? stripHTMLTags(chapter.description)
                    .split(".")
                    .filter((lesson) => lesson.trim().length > 0)
                    .map((lesson) => lesson.trim() + ".")
                : ["No content available"],
            };
          });
          setChapterContent(contentMap);
        }
      } else {
        setError("Failed to load chapter details");
        console.error("Failed to load blog data");
      }
    } catch (err) {
      setError("Error fetching chapter details");
      console.error("Error fetching blog:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchPackageDetail = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/course-package-subject`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ package_id: packageId }),
        }
      );
      const data = await response.json();
      setPackage(Array.isArray(data.data) ? data.data : []);
      setImagePath(data.imagePath || "");
      if (data.status === 1) {
        setImagePath(data.imagePath);
      } else {
        console.error("Failed to load blog data");
      }
    } catch (err) {
      console.error("Error fetching blog:", err);
    }
  };

  const stripHTMLTags = (html) => {
    if (!html) return "";
    return DOMPurify.sanitize(html, { ALLOWED_TAGS: [] });
  };

  const handleSubjectSelect = async (id) => {
    setActiveSubject(id);
    await fetchBlogDetail(id);
  };

  const handleContentMore = async (id) => {
    try {
      localStorage.setItem("con_Id", id);
      navigate("/course-detail-content-video");
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const toggleSubjectExpanded = async (id, e) => {
    e.stopPropagation();

    // If we're expanding this subject and it's not the active one, fetch its details
    if (!expandedSubjects[id] && activeSubject !== id) {
      setActiveSubject(id);
      await fetchBlogDetail(id);
    }

    setExpandedSubjects((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <>
      <section className="course">
        <div className="page_header"></div>
        <Container>
          <div className="course_detail subject py-60">
          
            <Row className="mb-5 align-items-center justify-content-between">
              <Col>
                <h2 className="mb-3 d-flex align-items-center">
                  <img src={author} alt="author" className="me-2 author-img" />
                  {blog?.title || "Course Details"}
                </h2>
                <p className="mb-4">
                  {stripHTMLTags(
                    blog?.description || "Select a subject to view details"
                  )}
                </p>
              </Col>

              {/* <Col xs="auto">
                <button
                  className="educate-btn btn-lg shadow-sm rounded-pill px-4"
                  onClick={() => navigate("/Test-Series")}
                >
                  Practice Test
                </button>
              </Col> */}
            </Row>

            <Row>
              <Col lg={4}>
                <div className="subject-sidebar">
                  <h4 className="mb-4">Subjects</h4>
                  {packagedata && packagedata.length > 0 ? (
                    packagedata.map((item, index) => (
                      <Card
                        key={index}
                        className={`subject-card mb-3 ${
                          activeSubject === item.id ? "active" : ""
                        }`}
                        onClick={() => handleSubjectSelect(item.id)}
                      >
                        <Card.Body>
                          <div className="d-flex align-items-center">
                            <img
                              className="subject-thumbnail"
                              src={
                                item?.image
                                  ? `${imagePath}${item.image}`
                                  : course
                              }
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = course;
                              }}
                              alt={item?.sub_name || "Subject Image"}
                            />
                            <div className="ms-3 flex-grow-1">
                              <h5 className="mb-1">{item.sub_name}</h5>
                              <div className="d-flex justify-content-between align-items-center mt-2">
                                <Badge bg="light" text="dark">
                                  {activeSubject === item.id
                                    ? Object.keys(chapterContent).length
                                    : item.chapter_count || 0}{" "}
                                  Chapters
                                </Badge>

                                <button
                                  className="educate-btn"
                                  onClick={(e) =>
                                    toggleSubjectExpanded(item.id, e)
                                  }
                                >
                                  <FaInfoCircle className="me-1" />
                                  {expandedSubjects[item.id]
                                    ? "Less"
                                    : "More"}{" "}
                                  Info
                                </button>
                              </div>
                            </div>
                          </div>

                          {expandedSubjects[item.id] && (
                            <div className="mt-3">
                              <p className="subject-description">
                                {stripHTMLTags(
                                  item?.description ||
                                    "No description available"
                                )}
                              </p>
                              {activeSubject === item.id && loading && (
                                <div className="text-center">
                                  <div
                                    className="spinner-border spinner-border-sm text-primary"
                                    role="status"
                                  >
                                    <span className="visually-hidden">
                                      Loading...
                                    </span>
                                  </div>
                                  <small className="d-block text-muted mt-1">
                                    Loading chapters...
                                  </small>
                                </div>
                              )}
                            </div>
                          )}
                        </Card.Body>
                      </Card>
                    ))
                  ) : (
                    <p>No subjects available</p>
                  )}
                </div>
              </Col>

              <Col lg={8}>
                <div className="content-sidebar">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="mb-0">Chapter Content</h4>
                    {activeSubject && (
                      <Badge bg="primary" pill>
                        {Object.keys(chapterContent).length} Chapters
                      </Badge>
                    )}
                  </div>

                  {loading && activeSubject && (
                    <div className="text-center p-5">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-2">Loading chapter details...</p>
                    </div>
                  )}

                  {error && (
                    <div className="alert alert-warning" role="alert">
                      {error}
                    </div>
                  )}

                  {activeSubject ? (
                    Object.keys(chapterContent).length > 0 ? (
                      <Accordion
                        defaultActiveKey="0"
                        className="chapter-accordion"
                      >
                        {Object.values(chapterContent).map((chapter, index) => (
                          <Accordion.Item
                            key={index}
                            eventKey={index.toString()}
                          >
                            <Accordion.Header>
                              <div className="d-flex align-items-center">
                                <span className="chapter-number badge bg-secondary me-2">
                                  {index + 1}
                                </span>
                                <span className="chapter-title">
                                  {chapter.title}
                                </span>
                              </div>
                            </Accordion.Header>
                            <Accordion.Body>
                              <h6 className="text-muted mb-3">
                                Lessons in this chapter:
                              </h6>
                              <ul className="lesson-list">
                                {chapter.lessons.map((lesson, i) => (
                                  <li
                                    key={i}
                                    className="d-flex align-items-center"
                                  >
                                    <FaPlay className="me-2 lesson-icon" />
                                    <span>{lesson}</span>
                                  </li>
                                ))}
                              </ul>
                              <div className="d-flex justify-content-end">
                                <button
                                  className="educate-btn"
                                  onClick={() => handleContentMore(chapter.id)}
                                >
                                  View Content Details{" "}
                                  <FaChevronRight className="ms-1" />
                                </button>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        ))}
                      </Accordion>
                    ) : (
                      !loading && (
                        <div className="text-center p-5 empty-state">
                          <h5>No chapters available</h5>
                          <p>This subject doesn't have any chapters yet.</p>
                        </div>
                      )
                    )
                  ) : (
                    <div className="text-center p-5 empty-state">
                      <h5>Select a subject</h5>
                      <p>
                        Choose a subject from the list to view its chapters and
                        content.
                      </p>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </>
  );
};

export default CoursesDetailSubject;
